import { Component, Input, OnInit } from '@angular/core';
import { InstructorModel } from '@bayclubs/group-classes-employee-api';

@Component({
    selector: 'app-instructor-label',
    templateUrl: './instructor-label.component.html',
    styleUrls: ['./instructor-label.component.scss'],
    standalone: false
})
export class InstructorLabelComponent implements OnInit {
    @Input() public nominalInstructor: InstructorModel;
    @Input() public substituteInstructor: InstructorModel;

    constructor() {}

    ngOnInit() {}
}
